import Carrot from 'lucide-react/dist/esm/icons/carrot';
import Package from 'lucide-react/dist/esm/icons/package';
import Snowflake from 'lucide-react/dist/esm/icons/snowflake';

/**
 * Box type visual configuration shared across ProgressBreakdown and StatusBreakdownTab.
 */
export const BOX_TYPE_CONFIG = {
    regular: {
        label: 'Regular',
        Icon: Carrot,
        iconClassName: 'text-orange-500',
    },
    frozen: {
        label: 'Frozen',
        Icon: Snowflake,
        iconClassName: 'text-blue-500',
    },
    oob: {
        label: 'OOB',
        Icon: Package,
        iconClassName: 'text-purple-500',
    },
};

/**
 * Human-readable labels for each status breakdown bucket.
 * Matches the granular statuses returned by the breakdown API.
 */
export const STATUS_LABELS = {
    prePurchase: 'Pre Purchase',
    labelPurchased: 'Label Purchased',
    labelPrinted: 'Label Printed',
    packed: 'Packed',
    onShippingPallet: 'On Shipping Pallet',
    onTruck: 'On Truck',
    shipped: 'Shipped',
    inTransit: 'In Transit',
    delivered: 'Delivered',
    issue: 'Issue',
    cancelled: 'Cancelled',
};

/**
 * Fixed render order for status rows within a box type section.
 */
export const STATUS_ORDER = [
    'prePurchase',
    'labelPurchased',
    'labelPrinted',
    'packed',
    'onShippingPallet',
    'onTruck',
    'shipped',
    'inTransit',
    'delivered',
    'issue',
    'cancelled',
];

/**
 * Statuses where aging is purely informational (label aging — time since purchase).
 * These statuses should NOT trigger warning/critical color-coding.
 */
export const INFORMATIONAL_AGING_STATUSES = new Set(['prePurchase', 'labelPurchased']);

/**
 * Aging thresholds (in minutes) for color-coding shipment chips.
 * Applies only to packing-related statuses (labelPrinted and beyond).
 * - Below WARNING: default text color
 * - WARNING to CRITICAL: orange
 * - Above CRITICAL: red
 */
export const AGING_THRESHOLDS = {
    WARNING: 60,
    CRITICAL: 120,
};

/**
 * Status filter values for client-side route filtering on the dashboard.
 */
export const STATUS_FILTER_VALUES = {
    ALL: 'all',
    CRITICAL: 'critical',
    AT_RISK: 'atRisk',
    ON_TRACK: 'onTrack',
};

export const STATUS_FILTER_OPTIONS = [
    { value: STATUS_FILTER_VALUES.ALL, label: 'All' },
    { value: STATUS_FILTER_VALUES.CRITICAL, label: 'Critical' },
    { value: STATUS_FILTER_VALUES.AT_RISK, label: 'At Risk' },
    { value: STATUS_FILTER_VALUES.ON_TRACK, label: 'On Track' },
];

export const STATUS_FILTER_TO_RISK_LEVEL = {
    [STATUS_FILTER_VALUES.CRITICAL]: 'CRITICAL',
    [STATUS_FILTER_VALUES.AT_RISK]: 'AT_RISK',
    [STATUS_FILTER_VALUES.ON_TRACK]: 'ON_TRACK',
};
